import { render, staticRenderFns } from "./BreadcrumbItem.vue?vue&type=template&id=0d3b0d7d&scoped=true"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbItem.vue?vue&type=style&index=0&id=0d3b0d7d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b0d7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3b0d7d')) {
      api.createRecord('0d3b0d7d', component.options)
    } else {
      api.reload('0d3b0d7d', component.options)
    }
    module.hot.accept("./BreadcrumbItem.vue?vue&type=template&id=0d3b0d7d&scoped=true", function () {
      api.rerender('0d3b0d7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/BreadcrumbItem.vue"
export default component.exports